"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("D:\\\u9879\u76EE\u7BA1\u7406\\\u65E7\u6362\u65B0\\\u6E90\u7801\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\@babel\\runtime\\regenerator\\index.js"));

var _tableList = _interopRequireDefault(require("./components/tableList"));

var _loginFrom = _interopRequireDefault(require("./components/loginFrom"));

var _register = _interopRequireDefault(require("./components/register"));

var _forgetPassword = _interopRequireDefault(require("./components/forgetPassword"));

var _forgetPhone = _interopRequireDefault(require("./components/forgetPhone"));

var _sms = require("@/api/sms");

var _vuex = require("vuex");

var _permission = require("@/utils/permission");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// 权限判断函数
var _default = {
  name: 'SmsConfig',
  components: {
    tableList: _tableList.default,
    loginFrom: _loginFrom.default,
    registerFrom: _register.default,
    forgetPassword: _forgetPassword.default,
    forgetPhone: _forgetPhone.default
  },
  data: function data() {
    return {
      fullscreenLoading: false,
      loading: false,
      smsAccount: '',
      circleUrl: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
      accountInfo: {},
      spinShow: false,
      isForgetPhone: false,
      // 修改手机号
      isIndex: false,
      // 判断忘记密码返回的路径
      isShowLogn: false,
      // 登录
      isShow: false,
      // 修改密码
      isShowReg: false,
      // 注册
      isShowList: false,
      // 登录之后列表
      sms: {
        open: 0
      },
      // 短信信息
      query: {
        open: 0
      },
      // 物流查询
      dump: {
        open: 0
      },
      // 电子面单打印
      copy: {
        open: 0
      },
      // 商品采集,
      infoData: {}
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['isLogin'])),
  mounted: function mounted() {
    this.onIsLogin(); // if (!this.isLogin) {
    //   this.onIsLogin()
    // } else {
    //   this.isShowList = true
    // }
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 开通服务
    openService: function openService(val) {
      this.getNumber();
    },
    onOpen: function onOpen(val) {
      this.$refs.tableLists.onOpenIndex(val);
    },
    // 手机号返回
    gobackPhone: function gobackPhone() {
      this.isShowList = true;
      this.isForgetPhone = false;
    },
    onChangePhone: function onChangePhone() {
      this.isForgetPhone = true;
      this.isShowLogn = false;
      this.isShowList = false;
    },
    // 密码返回
    goback: function goback() {
      if (this.isIndex) {
        this.isShowList = true;
        this.isShow = false;
      } else {
        this.isShowLogn = true;
        this.isShow = false;
      }
    },
    // 修改密码
    onChangePassswordIndex: function onChangePassswordIndex() {
      this.isIndex = true;
      this.passsword();
    },
    // 忘记密码
    onChangePasssword: function onChangePasssword() {
      this.isIndex = false;
      this.passsword(); // this.isShowLogn = false;
      // this.isShow = true;
      // this.isShowList = false;
    },
    passsword: function passsword() {
      this.isShowLogn = false;
      this.isShow = true;
      this.isShowList = false;
    },
    mealPay: function mealPay(val) {
      this.$router.push({
        path: '/operation/systemSms/pay',
        query: {
          type: val
        }
      });
    },
    // 剩余条数
    getNumber: function getNumber() {
      var _this = this;

      this.loading = true;
      (0, _sms.smsInfoApi)().then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee(res) {
          var data;
          return _index.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  data = res;
                  _this.infoData = res;
                  _this.sms = {
                    num: data.sms.num,
                    open: data.sms.open,
                    surp: data.sms.open
                  };
                  _this.query = {
                    num: data.query.num,
                    open: data.query.open,
                    surp: data.query.open
                  };
                  _this.dump = {
                    num: data.dump.num,
                    open: data.dump.open,
                    surp: data.dump.open
                  };
                  _this.copy = {
                    num: data.copy.num,
                    open: data.copy.open,
                    surp: data.copy.open
                  };
                  _this.loading = false;
                  _this.smsAccount = data.account;
                  _this.accountInfo = data;

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this.isShowLogn = true;
        _this.isShowList = false;
        _this.loading = false;
      });
    },
    // 登录跳转
    onLogin: function onLogin() {
      var url = this.$route.query.url;

      if (url) {
        this.$router.replace(url);
      } else {
        this.getNumber();
        this.isShowLogn = false;
        this.isShow = false;
        this.isShowReg = false;
        this.isShowList = true;
      }
    },
    // 查看是否登录
    onIsLogin: function onIsLogin() {
      var _this2 = this;

      this.fullscreenLoading = true;
      this.$store.dispatch('user/isLogin').then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee2(res) {
          var data;
          return _index.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  data = res;
                  _this2.isShowLogn = !data.status;
                  _this2.isShowList = data.status;

                  if (data.status) {
                    _this2.smsAccount = data.info;

                    _this2.getNumber();
                  }

                  _this2.fullscreenLoading = false;

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this2.fullscreenLoading = false;
        _this2.isShowLogn = true;
      });
    },
    // 退出登录
    signOut: function signOut() {
      var _this3 = this;

      (0, _sms.logoutApi)().then( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee3(res) {
          return _index.default.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _this3.isShowLogn = true;
                  _this3.isShowList = false;
                  _this3.infoData.phone = '';

                  _this3.$store.dispatch('user/isLogin');

                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    // 立即注册
    onChangeReg: function onChangeReg() {
      this.isShowLogn = false;
      this.isShow = false;
      this.isShowReg = true;
    },
    // 立即登录
    logoup: function logoup() {
      this.isShowLogn = true;
      this.isShow = false;
      this.isShowReg = false;
    }
  }
};
exports.default = _default;